import React, { useState, useEffect, useRef } from "react";
import AbstractsData from "./data/abstractsData";
import Footer from "./Footer";

function Abstracts() {
  const [activeYear, setActiveYear] = useState(null);
  const [yearSections, setYearSections] = useState([]);
  const contentRef = useRef(null);

  useEffect(() => {
    // Get all h2 elements (year headings)
    const h2s = contentRef.current.querySelectorAll("h2");
    const sections = [];

    h2s.forEach((h2, index) => {
      const year = h2.textContent.trim();
      const sectionElements = [];

      let el = h2.nextElementSibling;
      while (el && el.tagName !== "H2") {
        sectionElements.push(el.outerHTML);
        el = el.nextElementSibling;
      }

      sections.push({
        year,
        content: `<h2>${year}</h2>${sectionElements.join("")}`,
      });
    });

    setYearSections(sections);
    if (sections.length > 0) {
      setActiveYear(sections[0].year);
    }
  }, []);

  return (
    <div className="container mt-4">
      <h2>Abstracts of Publications</h2>

      {/* Tabs */}
      <ul className="nav nav-tabs" role="tablist">
        {yearSections.map((section) => (
          <li
            key={section.year}
            className="tab-item"
            onClick={() => setActiveYear(section.year)}
            style={{ cursor: "pointer", userSelect: "none" }}
          >
            <button className={`nav-link ${activeYear === section.year ? "active" : ""}`}>
              {section.year}
            </button>
          </li>
        ))}
      </ul>

      {/* Tab content */}
      <div className="tab-content mt-3">
        {yearSections
          .filter((section) => section.year === activeYear)
          .map((section) => (
            <div
              key={section.year}
              className="tab-pane fade active show"
              dangerouslySetInnerHTML={{ __html: section.content }}
            />
          ))}
      </div>

      {/* Hidden AbstractsData to extract content from */}
      <div ref={contentRef} style={{ display: "none" }}>
        <AbstractsData />
      </div>
      <Footer/>
    </div>
  );
}

export default Abstracts;
